import { styled } from '@nykaa/ui-components';
import { css } from '@emotion/core';

// constants
import { MWEB_PLACEHOLDER_HEIGHTS } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductOffers/constants';
import { BREAKPOINTS, BASE_GUTTER_SPACE } from 'shared/styles/base';

export const PlaceholderWrapper = styled.div<{ parentOverflow?: boolean }>`
  ${({ parentOverflow, theme }) =>
    parentOverflow
      ? `
  position: relative;
  margin: 0px -${theme.spacing.spacing80};
  background: ${theme.colors.pdpCouponsSectionBg};
  width: 100vw;`
      : `width: 100%;`};

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-left: ${({ theme }) => theme.spacing.spacing80};
  }
`;

export const PlaceholderContainer = styled.div`
  max-width: 100%;
  overflow: hidden;
  ${({ theme }) => css`
    margin-top: ${theme.spacing.spacing80};
    @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
      padding-top: ${theme.spacing.spacing80};
      margin-top: ${theme.spacing.spacing0};
    }
  `};
`;

export const CouponTitle = styled.div`
  width: 50%;
  height: ${MWEB_PLACEHOLDER_HEIGHTS.TITLE}px;
  background-color: ${({ theme }) => theme.colors.shimmerBg};
`;

export const CouponContainer = styled.div`
  width: 100%;
  height: ${MWEB_PLACEHOLDER_HEIGHTS.COUPON_CARD}px;
  background-color: ${({ theme }) => theme.colors.shimmerBg};
  ${({ theme }) => `
    margin-top: ${theme.spacing.spacing80};
    margin-bottom: ${theme.spacing.spacing120};
  `};
`;

export const OfferTitle = styled.div`
  width: 50%;
  height: ${MWEB_PLACEHOLDER_HEIGHTS.TITLE}px;
  background-color: ${({ theme }) => theme.colors.shimmerBg};
`;

export const OfferContainer = styled.div`
  width: 100%;
  height: ${MWEB_PLACEHOLDER_HEIGHTS.OFFER_CARD}px;
  background-color: ${({ theme }) => theme.colors.shimmerBg};
  ${({ theme }) => `
    margin-top: ${theme.spacing.spacing80};
    margin-bottom: ${theme.spacing.spacing80};
  `};
`;

export const PlaceholderSeparator = styled.div`
  width: calc(100% + ${BASE_GUTTER_SPACE * 4}px);
  height: 1px;
  background: ${({ theme }) => theme.colors.textOutline};
  ${({ theme }) => `margin: 0 0 ${theme.spacing.spacing80} -${theme.spacing.spacing80}`};
`;
